<template>
    <vs-popup classContent="popup-example"  title="ویرایش مدیا" :active.sync="showPopup">
        <form class="px-4" @keydown.enter="editAcademyInfo()">
            <div class="vx-row px-5 mb-4">
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">عنوان</label>
                    <vs-input class="w-full mt-2" v-model="title" />
                </div>
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">آدرس فایل</label>
                    <vs-input class="w-full mt-2" v-model="url" />
                </div>
                <div class="vx-col w-1/2 upload-btn-wrapper mt-4">
                    <label class="vs-input--label">آپلود عکس</label>
                    <b-form-file
                        v-model="file"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        accept="image/*"
                    />
                    <!-- <input type="file" id="file" ref="file"  @change="uploadImg()" /> -->
                </div>
                <div class="vx-col w-1/7 mt-4">
                    <img v-if="srcFile" :src="srcFile" style="width: 100px;height:auto;">
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">توضیحات</label>
                    <vs-textarea v-model="text" rows="4" />
                </div>
            </div>

            <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-col class="sm:w-1/2 w-full">
                    
                </vs-col>
                <vs-col class="sm:w-1/2 w-full">
                    <vs-button class="mr-3 float-right" @click="editAcademyInfo()">ثبت</vs-button>
                </vs-col>
            </vs-row>
        </form>
    </vs-popup>
</template>

<script>
import { Validator } from 'vee-validate';
import { BFormFile } from 'bootstrap-vue'

const dict = {
    custom: {
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    name: 'EditAcademy',

    props: {
        popupEditAcademy: {
            type: Boolean,
            default: false,
        },
        academyId: Number
    },
    
    components: {
        BFormFile
    },
    
    data() {
		return{
            showPopup: false,
            file: [],
            title: '',
            url: '',
            thumbnail: '',
            text: '',
            srcFile: ''
		}
    },
    
    computed: {
    },

    watch: { 
      	popupEditAcademy: function(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getPostInfo', this.academyId)
                .then(res => {
                    localStorage.setItem('postId', this.academyId)
                    this.title = res.data[0].title
                    this.thumbnail = res.data[0].thumbnail
                    this.text = res.data[0].text
                    this.url =res.data[0].url
                    this.srcFile = 'https://appapi.akambc.com/' + this.thumbnail
                    this.$vs.loading.close()
                }).catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditAcademy', newVal)
            this.title= ''
            this.url = ''
            this.thumbnail = ''
            this.text = ''
        },
    },

    created(){	
    },
    
    methods: {
        uploadVideo(files) {
            this.academy.url = files[0]
        },

        uploadImg() {
            this.file = this.$refs.file.files[0];
        },

        editAcademyInfo() {
            this.$vs.loading()
            let formData = new FormData();
            formData.append('thumbnail', this.file);
            formData.append('title', this.title);
            formData.append('text', this.text);
            formData.append('order', 0);
            formData.append('type', 'academy');
            formData.append('url', this.url);
            this.$emit('updatePopupEditAcademy', false)
            
            this.$store.dispatch('updatePostInfo', formData)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'آکادمی با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        }
    }
}
</script>

<style scope>
.con-vs-popup .vs-popup {
    width: 50% !important;
}

.upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
}
</style>